import { render, staticRenderFns } from "./MovimientoList.vue?vue&type=template&id=16d2d12d&scoped=true&"
import script from "./MovimientoList.vue?vue&type=script&lang=js&"
export * from "./MovimientoList.vue?vue&type=script&lang=js&"
import style0 from "./MovimientoList.vue?vue&type=style&index=0&id=16d2d12d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d2d12d",
  null
  
)

export default component.exports